import { TAG_TYPE } from '../constants/bucket.contants'
import { TagType } from '../types/bucketTypes'

export const getImgSrc = (tagData: TagType, forMap?: boolean) => {
    let src = ''
    if (tagData?.tag_type == TAG_TYPE.SATELLITE) {
        src = require(forMap
            ? '../assets/sat_marker.png'
            : '../assets/sat_icon.png')
    } else if (tagData?.tag_type == TAG_TYPE.CELL_TOWER) {
        src = require(forMap
            ? '../assets/cell_marker.png'
            : '../assets/cell_icon.png')
    } else {
        src = require(forMap
            ? '../assets/bluetooth_marker.png'
            : '../assets/bluetooth_icon.png')
    }
    return src
}
